import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { whatsappIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';

interface WhatsAppShareRoundProps {
  className?: string;
  message: string;
}

export const WhatsAppShareRound: React.FunctionComponent<WhatsAppShareRoundProps> = ({
  className,
  message,
}) => {
  return (
    <IconButton className={`${styles.roundButton} ${className}`}>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(message)}`}
        data-qa="whatsapp-btn"
      >
        <div className={classNames(styles.iconWrapper, styles.whatsApp)}>
          <Svg markup={whatsappIcon} className={styles.icon} />
        </div>
        WhatsApp
      </a>
    </IconButton>
  );
};
